import { Socket, io } from "socket.io-client";

import Cookies from "js-cookie";
import configs from "../../config/index";

export const socket = io(`${configs.API_DOMAIN}/socket` || "", {
  transports: ["websocket", "polling"],
  auth: {
    token: Cookies.get("token"),
  },
});

socket.on("connect", () => {
  authenticateSocket();
});

export const authenticateSocket = async () => {
  if (Cookies.get("token")) {
    socket.emit("authenticate", { token: Cookies.get("token"), role: "User" });
  }
};

interface IConfigSocket {
  query?: Record<string, any>;
  apiDomain?: string;
}

export class SocketClient {
  public socket: Socket;

  constructor({
    query,
    apiDomain = `${configs.API_DOMAIN}/socket`,
  }: IConfigSocket) {
    this.socket = io(apiDomain || "", {
      transports: ["websocket", "polling"],
      auth: {
        token: Cookies.get("token"),
      },
      query,
    });

    this.socket.on("connect", () => {
      authenticateSocket();
    });
  }

  authenticateSocket = async () => {
    if (Cookies.get("token")) {
      this.socket.emit("authenticate", {
        token: Cookies.get("token"),
        role: "User",
      });
    }
  };
}
